import { compose } from 'redux'
import { connect } from 'react-redux'
import { listar_obj } from '../../../../../DinamicForms/actions';



const mapStateToProps = (state, props) => {
    const { DinamicCustomFormsReducer } = state

    const controler = DinamicCustomFormsReducer.rLista;
    let lista = controler.lista;
    let customFormInterno = null;
    lista.forEach(f => {
        if (f.uid === props.customFormUid) {
            customFormInterno = f;
        }
    });

    let chaveReducer = props.customFormUid;
    let loading = true;
    let listaItens = []


    if (customFormInterno) {
        if (customFormInterno.chaveSalvar) {
            chaveReducer = customFormInterno.chaveSalvar
        }


        if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
            loading = DinamicCustomFormsReducer.rListaObj[chaveReducer].loading;
            listaItens = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
        }
    }

    let tags = [];
    listaItens.forEach(obj => {
        if (obj[props.item.field]) {
            obj[props.item.field].forEach(item => {
                if (tags.indexOf(item) === -1) {
                    tags.push(item);
                }
            });
        }
    });

    return {
        customFormInterno, possiveis: tags, loading
    };
};


export default compose(
    connect(mapStateToProps, { listar: listar_obj }),
);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Tags/components/Tags/Tags.enhancer.js